import React, { useState, useEffect } from 'react';
import { Box, Typography, Button } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';

const VerifyEmailPage = ({ setUser }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Автоматическое подтверждение по ссылке
    const pathParts = location.pathname.split('/');
    const codeFromUrl = pathParts[pathParts.length - 1]; // Берем код из URL

    if (codeFromUrl && codeFromUrl.length > 10) {
      verifyCodeFromUrl(codeFromUrl); // Автоматическая проверка
    } else {
      setError('Некорректная ссылка подтверждения.');
    }
  }, [location]);

  const verifyCodeFromUrl = async (code) => {
    setLoading(true);
    setError('');
    setSuccessMessage('');

    try {
      const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/api/auth/verify-email/${code}`);
      const data = await response.json();

      if (response.ok) {
        localStorage.setItem('token', data.token); // Сохраняем токен
        setUser(data.user); // Устанавливаем пользователя
        setSuccessMessage('Email успешно подтвержден. Выполняется вход...');
        setTimeout(() => navigate('/'), 1500); // Перенаправляем на главную страницу
      } else {
        setError(data.message || 'Ошибка подтверждения.');
      }
    } catch (error) {
      console.error('Ошибка подтверждения через ссылку:', error.message);
      setError('Произошла ошибка. Попробуйте снова.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        maxWidth: 400,
        margin: '50px auto',
        padding: 3,
        boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
        borderRadius: 2,
        backgroundColor: '#fff',
        textAlign: 'center',
      }}
    >
      <Typography variant="h5" gutterBottom>
        Подтверждение Email
      </Typography>
      {successMessage && (
        <Typography color="primary" variant="body2" gutterBottom>
          {successMessage}
        </Typography>
      )}
      {error && (
        <Typography color="error" variant="body2" gutterBottom>
          {error}
        </Typography>
      )}
      {loading && (
        <Button
          variant="contained"
          disabled
          fullWidth
          sx={{ mt: 2 }}
        >
          Подтверждение...
        </Button>
      )}
    </Box>
  );
};

export default VerifyEmailPage;
